import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ChannelsandoperationsService } from 'src/app/services/channelsandoperations.service';
import { AuthService } from 'src/app/services/auth.service';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { RolService } from 'src/app/services/rol.service';

import { DesicionComponent } from '../../dialogs/desicion/desicion.component';
import { MatSnackBar } from '@angular/material/snack-bar';

// DIALOGS
import { EditarCanalComponent } from '../../dialogs/editar/editar-canal/editar-canal.component';
import { CanalComponent } from '../../dialogs/crear/canal/canal.component';

// TABLE
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

class Canal {
  id_canales: string;
  nombre: String;
  borrado: String;
  createdAt: Date;
  updatedAt: Date;
}

@Component({
  selector: 'app-channelsandoperations',
  templateUrl: './channelsandoperations.component.html',
  styleUrls: ['./channelsandoperations.component.scss'],
})
export class ChannelsandoperationsComponent implements OnInit {
  dtOptions: any = {};
  channels: any = [];
  operations: any = [];
  idUser;
  submitted = false;
  channelCreateForm: FormGroup;
  dtTrigger: Subject<any> = new Subject();
  // @ViewChild(DataTableDirective)
  dtElement;

  // TABLE
  buscar = '';
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = ['nombre', 'opciones'];
  dataSource = new MatTableDataSource<Canal>();

  crearTipos: boolean = false;
  actualizarTipos: boolean = false;
  eliminarTipos: boolean = false;

  constructor(
    private authService: AuthService,
    private actRoute: ActivatedRoute,
    private channelAndOperationService: ChannelsandoperationsService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private rolService: RolService,
    private pag: MatPaginatorIntl,
  ) {
    this.pag.itemsPerPageLabel = "Canal/Operaciones por página";
    this.pag.nextPageLabel = "Siguiente";
    this.pag.previousPageLabel = "Anterior";

    //console.log(this.rolService.permisos)
    let permisos = this.rolService.permisos;
    for (let i in this.rolService.permisos) {
      permisos[i].indexOf("Crear Tipos") !== -1 ? this.crearTipos = true : null
      permisos[i].indexOf("Actualizar Tipos") !== -1 ? this.actualizarTipos = true : null
      permisos[i].indexOf("Eliminar Tipos") !== -1 ? this.eliminarTipos = true : null
    }
    this.idUser = sessionStorage.getItem('id_usuario');
    // this.getChannels();
    this.cargarCanales();
    this.buildChannelCreateForm();
  }

  ngOnInit(): void { }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  getChannels() {
    this.channelAndOperationService.getChannels().subscribe((channel) => {
      //console.log(channel);
      this.channels = channel;
      this.dtTrigger.next();
    });
  }

  cargarCanales() {
    this.channels = [];
    this.channelAndOperationService.getChannels().subscribe((channel) => {
      this.channels = channel.payload;
      //console.log(channel);
      this.dataSource = new MatTableDataSource<Canal>(this.channels);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  search() {
    this.dataSource.filter = this.buscar;
  }

  private buildChannelCreateForm() {
    this.channelCreateForm = this.fb.group({
      nombre: ['', [Validators.required]],
      id_usuarios_creador: [this.idUser],
      borrado: [0],
    });
    this.channelCreateForm.valueChanges.subscribe((value) => {
      //console.log(value);
    });
  }

  eliminar(id_channel) {
    const dialogRef = this.dialog.open(DesicionComponent, {
      width: '500px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      //console.log(result);
      if (result == 'true') {
        //console.log('Borrando');
        this.channelAndOperationService
          .deleteChannel(id_channel, sessionStorage.getItem('id_usuario'))
          .subscribe((data) => {
            //console.log(data);
          });
        this.openSnackBar('Canal eliminado con éxito.', 'X');
      } else {
      }
      this.cargarCanales();
    });
  }

  editar(channel) {
    const dialogRef = this.dialog.open(EditarCanalComponent, {
      width: '500px',
      data: channel,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.cargarCanales();
    });
  }

  crear() {
    const dialogRef = this.dialog.open(CanalComponent, {
      width: '500px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.cargarCanales();

      if (result) {
        this.openSnackBar('Canal creado con éxito.', 'X');
      }
    });
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  onSubmit() {
    this.submitted = false;
    if (!this.channelCreateForm.valid) {
      return false;
    } else {
      //console.log(this.channelCreateForm.value);
      this.channelAndOperationService
        .createChannel(this.channelCreateForm.value)
        .subscribe(
          (res) => {
            //console.log('canales successfully created!');
            //console.log(res);
            this.cargarCanales();
            if (res.message == 'El nombre de los campos debe ser único.') {
              this.openSnackBar('El nombre de los campos debe ser único.', 'X');
            } else {
              this.openSnackBar('El canal se ha creado con éxito.', 'X');
            }
          },
          (error) => {
            //console.log(error);
          }
        );
    }
    // this.channelCreateForm.reset();
  }

  guardarIdCanal(id) {
    sessionStorage.setItem('id_canales', id);
  }
}
